require('./accountPrecautionaryWarningsDetails.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const  { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const AccountPrecautionaryWarningsDetailRow = require('components/contactCenter/accountPrecautionaryWarnings/accountPrecautionaryWarningsDetail/accountPrecautionaryWarningsDetailRow/accountPrecautionaryWarningsDetailRow');
// @constants
const ACCOUNT_PRECAUTIONARY_WARNINGS = require('constants/contactCenter/accountPrecautionaryWarnings');
// @actions
const { requestPrecautionaryWarnings } = require('actions/contactCenter/accountPrecautionaryWarnings');
const { requestPrecautionaryWarningsNextPage } = require('actions/contactCenter/accountPrecautionaryWarnings')

class AccountPrecautionaryWarningsDetail extends React.Component {

    constructor(props) {
        super(props);
        this.handleRetry = this.handleRetry.bind(this);
        this.getWarnings = this.getWarnings.bind(this);
        this.handleNextPageRequestClick = this.handleNextPageRequestClick.bind(this);
    }

    handleRetry() {
        this.getWarnings();
    }

    getWarnings() {
      const { immAccount, requestPrecautionaryWarnings } = this.props;
      const accountId = immAccount.get('accountId');
      requestPrecautionaryWarnings(accountId);
    }

    buildContent() {
        const { immWarnings } = this.props;

        if (immWarnings.get('isFetching')) {
            return <LoadingSection />;
        }

        if (immWarnings.get('error')) {
            return this.buildEmptyState('accountPrecautionaryWarnings-errorConnectionMessage');
        }

        if (!immWarnings.get('byOrder').count()) {
            return this.buildEmptyState('accountPrecautionaryWarnings-noResults')
        }

        return this.buildTable();
    }

    buildEmptyState(messageKey) {
        const message = formatText(messageKey);
        const retryButton = (
            <OKButton onClick={this.handleRetry}>
                <FormattedText value="accountPrecautionaryWarnings-retryButton" />
            </OKButton>
        );

        return (
            <EmptyState
                primaryText={message}
                button={retryButton}
            />
        );
    }

    buildTable() {
        const { immWarnings } = this.props;
        const immWarningsById = immWarnings.get('byId');
        const immWarningsByOrder = immWarnings.get('byOrder');

        return (
            <LastMovementsTable
                rowComponent={AccountPrecautionaryWarningsDetailRow}
                immTransactionsById={immWarningsById}
                immTransactionsByOrder={immWarningsByOrder}
                columnsCount={5}
                id="account-warnings-table"
                groupByDate={true}
                language={getLanguage()}
            >
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell
                            asHeader={true}
                            className=""
                        >
                            <FormattedText value="accountPrecautionaryWarnings-dischargeDate" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className=""
                        >
                            <FormattedText value="accountPrecautionaryWarnings-typology" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className=""
                        >
                            <FormattedText value="accountPrecautionaryWarnings-description" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className=""
                        >
                            <FormattedText value="accountPrecautionaryWarnings-startDate" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className=""
                        >
                            <FormattedText value="accountPrecautionaryWarnings-endDate" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            </LastMovementsTable>
        );
    }

    buildNextPageLink() {
        const {immWarnings} = this.props;

        let content;
        if (immWarnings.get('isFetchingNextPage')) {
            content = <LoadingSection />
        } else {
            content = (
                <div className="text-right">
                    <OKButton
                        onClick={this.handleNextPageRequestClick}
                        modifier="additional-action-primary"
                    >
                        <FormattedText
                            value="accountPrecautionaryWarnings-loadMore"
                            format="uppercase"
                        />
                    </OKButton>
                </div>
            );
        }

        return content;
    }

    handleNextPageRequestClick() {
        const { immAccount, requestPrecautionaryWarningsNextPage } = this.props;
        const accountId = immAccount.get('accountId');
        requestPrecautionaryWarningsNextPage(accountId);
    }

    render() {
        const { immWarnings } = this.props;
        const headerTitle = formatText('accountPrecautionaryWarnings-title');

        let content = <LoadingSection />
        let requestNextPageButton;

        if (immWarnings) {
            content = this.buildContent();
            if (ACCOUNT_PRECAUTIONARY_WARNINGS.NO_END_LIST === immWarnings.get('endList')) {
              requestNextPageButton = this.buildNextPageLink();
            }
        }

        return (
            <section className="account-warnings-details">
                <header>
                    <OKBoxTitle value={headerTitle} inline={true} />
                </header>
                {content}
                {requestNextPageButton}
            </section>
        );
    }

}

AccountPrecautionaryWarningsDetail.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immWarnings: PropTypes.object,
    requestPrecautionaryWarnings: PropTypes.func.isRequired,
    requestPrecautionaryWarningsNextPage: PropTypes.func.isRequired
};

module.exports = AccountPrecautionaryWarningsDetail;
module.exports.AccountPrecautionaryWarningsDetail = connect(
    state => ({
        immWarnings: state.accountPrecautionaryWarnings
    }),
    {
        requestPrecautionaryWarnings: requestPrecautionaryWarnings,
        requestPrecautionaryWarningsNextPage: requestPrecautionaryWarningsNextPage
    }
)(AccountPrecautionaryWarningsDetail);
